module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('main', [_c('router-view', {
    attrs: {
      "user": _vm.user
    }
  })], 1), _vm._v(" "), _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer__left"
  }, [_c('a', {
    attrs: {
      "href": "https://graph.cool",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.graphcoolBadge,
      "alt": ""
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://netlify.com",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.netlifyBadge,
      "alt": ""
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/nielslanting/nade-spots",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.githubBadge,
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "footer__right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Disclaimer'
      }
    }
  }, [_vm._v("\n        Dislaimer\n      ")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Terms'
      }
    }
  }, [_vm._v("\n        Terms\n      ")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-427a9fc7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 711
// module chunks = 1